module.exports = __webpack_public_path__ + "img/chicken-picante.706a8c34.jpg";